// extracted by mini-css-extract-plugin
export var collapsedSummary = "_km-0";